import { guestOSCountsDto } from '../dto/guestOSCountsDto';
import { tableViewModel } from '../views/tableViewModel';

export class guestOSCountTransformer {
  public static from(guestOSCount: guestOSCountsDto): tableViewModel[] {
    return <tableViewModel[]>[
      {
        name: 'Windows',
        value: guestOSCount.windows == null ? '-' : guestOSCount.windows.toString()
      },
      {
        name: 'Linux',
        value: guestOSCount.linux == null ? '-' : guestOSCount.linux.toString()
      },
      {
        name: 'Other',
        value: guestOSCount.other == null ? '-' : guestOSCount.other.toString()
      }
    ];
  }
}
